export function getCookie(name: string): string {
  if (typeof window !== 'undefined') {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const c = cookies[i].trimStart();

      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
  }

  return '';
}
